import PropTypes from 'prop-types';
import React from 'react';
import {titleTemplate} from 'utils/seoUtils';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';

const helmetProps = {
  titleTemplate: titleTemplate.football
}

export default function FootballComponent({children}) {
  return (
    <div className="football-content">
      <MetaDataWrapper helmetProps={helmetProps} />
      {children}
    </div>
  );
}

FootballComponent.propTypes = {
  children: PropTypes.any
}



// WEBPACK FOOTER //
// ./modules/Football/components/Football.js